export const allRequestsBlockTypesTest = [
    // Альтитуда из разных источников
    'altitude',
    //Параметры накопл. показателей по скв.
    'collectedWellParams',
    // Изолированные интервалы перфорации
    'isolatedPerforationsInterval',
    // Отчёт по работам повышения нефтеотдачи
    'increaseOilTaking',
    //Данные по планируемым ГТМ
    'plannedGtmData',
    // Начало добычи, закачки и эксплуатации
    'drillingData',
    // Данные по бурению, ликвидации
    'drillingAndAbandonmentData',
    // Текущий жесткий забой
    'currentHardBottom',
    // Данные из табличных заключений по ГИС
    'gisTabularConclusions',
    // Данные по геолого-химическим исследованиям
    'geoChemicalResearchData',
    // Данные по гидродинамическим исследованиям с ИПТ
    'hydrodynamicResearchIptData',
    // Данные по герметичности цементного камня
    'cementStoneIntegrityData',
    // Документы по ГИС-бурению
    'gisDrillingDocuments',
    // Параметры кривых ГИС в бурящихся скважинах почему то используется как ключ Статистика ввода ГИС-контроля
    'gisCurvesParamsDrillingWells',
    // Данные по ГИС-контролю
    'gisControlData',
    // Данные по ГИС-контролю табличные заключения
    'gisControlTabularConclusions',
    // Документы по ГИС-контролю
    'gisControlDocuments',
    // Длинные исследования
    'longTermResearch',
    // Негерметичность эксплуатационной колонны
    'casingLeakage',
    // Пластовые давления по скважинам
    'reservoirPressuresByWells',
    // Данные по выполненным ГТМ
    'performedGtmData',
    // Технологические замеры
    'technologicalMeasurements',
    // Данные по изоляции
    'isolationData',
    // Существующие интервалы изоляции
    'existingIsolationInterval',
    // Данные по инклинометрии
    'inclinationData',
    // Данные по испытаниям
    'testingData',
    // Объекты разработки
    'developmentObjects',
    // Параметры добычи нефти
    'oilProductionParams',
    // Параметры закачки
    'injectionParams',
    // Параметры добычи газа
    'gasProductionParams',
    // Данные по керну
    'coreData',
    // Данные по консервации скважин
    'wellConservationData',
    // Данные по конструкции скважин
    'wellConstructionData',
    // Данные по координатам
    'coordinatesData',
    // Данные по ликвидации скважин
    'wellAbandonmentData',
    // Данные по бурению, ликвидации (дублируется)
    'drillingAndAbandonmentDataDuplicate',
    // Параметры работы скважины
    'wellOperationParams',
    // Траектория скважины
    'wellTrajectory',
    // Данные по освоению
    'wellCompletionData',
    // Данные по ИД
    'idData',
    // Данные по КВУ
    'kvuData',
    // Данные по перфорации
    'perforationData',
    // Открытые интервалы по перфорации
    'openPerforationIntervals',
    // Освоенные интервалы перфорации
    'completedPerforationIntervals',
    // Перфорированные пласты
    'perforatedReservoirs',
    // Перфорированные пласты перфорация
    'perforatedReservoirs22',
    // Геофизический прибор
    'geophysicalInstrument',
    // Насосы
    'pumps',
    // Система телеметрии
    'telemetrySystem',
    // Разбивки по скважинам
    'wellBreakdownData',
    // Данные по текущему фонду
    'currentWellStockData',
    // Данные по накопленному фонду
    'accumulatedWellStockData',
    // Данные реестра
    'registryData',
    // Полный реестр скважин
    'fullWellRegistry',
    // Горизонтальные скважины
    'horizontalWells',
    // Формирование отчетов по результатам ГДИС
    'gdisReportGeneration',
    // Акты из OIS
    'oisActs',
    // Отчет по ремонтам-ПКРС
    'pkrRepairReport',
    // Отчет по ремонтам-бурение
    'drillingRepairReport',
    // Отчет по ремонтам-освоение
    'completionRepairReport',
    // Сводка по ремонтам-ПКРС
    'pkrRepairSummary',
    // Сводка по ремонтам-бурение
    'drillingRepairSummary',
    // Сводка по ремонтам-освоение
    'completionRepairSummary',
    // Работы по ликвидации скважин
    'wellAbandonmentWorks',
    // Работы по консервации скважин
    'wellConservationWorks',
    // Данные по стратиграфии
    'stratigraphyData',
    // Глубинные пробы нефти
    'deepOilSamples',
    // Компонентный состав нефти
    'oilComponentComposition',
    // Поверхностные пробы нефти
    'surfaceOilSamples',
    // Состав воды
    'waterComposition',
    // Состав попутного газа
    'associatedGasComposition',
    // Состав стабильного конденсата
    'stableCondensateComposition',
    // Состав растворенного газа
    'dissolvedGasComposition',
    // Состав свободного газа
    'freeGasComposition',
    // Диф. дегазирование нефти
    'differentialOilDegassing',
    // Данные о количестве проб в БД Флюидов
    'fluidSamplesCountInDb',
] as const;

export const DRILLING_TYPES = ['drillingData', 'drillingAndAbandonmentData', 'currentHardBottom'] as const;
export const GIS_CONTROL_CONCLUSION_TYPES = [
    'ipPartsProfile',
    'flowMeteringResearch',
    'newWellAccompaniment',
    'gisControlData',
    'dataOnGISControl',
    'dataOnGISControlTableConclusions',
    'documentsOnGISControl',
    'longResearches',
    'casingLeakage',
    'reservoirPressuresByWells',
    'gisCurvesParamsDrillingWells',
] as const;
export const INCLINOMETRY_TYPES = [
    'inclinationData',
    'controlInclinometry',
    'inclinometryVnk',
    'wellPath',
    'shapeFiles',
] as const;
export const ISOLATION_TYPES = [
    'coreData10',
    'isolationData',
    'existingIsolationInterval',
    'currentHardBottom',
    'isolatedPerforationsInterval',
    'perforationDinamic',
] as const;
export const DRILLING_HISTORY_TYPES = [
    'drillingData',
    'collectedWellParams',
    'perforationsHistory',
    'developmentObjects',
    'gasProductionParams',
    'oilProductionParams',
    'injectionParams',
    'wellsResearchData',
    'wellsMeasure',
    'collectedGazWellParams',
] as const;
export const CORE_TYPES = ['coreData'] as const;
export const CONSERVATION_TYPES = ['wellConservationData'] as const;
export const CONSTRUCTION_TYPES = ['wellConstructionData'] as const;
export const PERFORATION_TYPES = [
    'analysisOfExtractionAndPerforationObjects',
    'perforationData',
    'openPerforationIntervals',
    'completedPerforationIntervals',
    'perforatedReservoirs22',
    'perforatedSeams',
    'isolatedPerforationsInterval',
    'ipPartsProfile',
    'perforationDinamic',
    'perforationsHistory',
] as const;
export const DEVELOPMENT_TYPES = ['idData', 'kvuData', 'wellCompletionData', 'completedPerforationIntervals'] as const;
export const TEXHNICAL_INFORMATION_ON_WELLS = [
    'idData',
    'kvuData',
    'drillingAndAbandonmentData',
    'isolationData',
    'testingData',
    'wellConstructionData',
    'wellCompletionData',
    'perforationData',
    'wellsTechState',
] as const;
export const GIS_DRILLING_CONCLUSION_TYPES = [
    'cementStoneIntegrityData',
    'gisTabularConclusions',
    'geoChemicalResearchData',
    'hydrodynamicResearchIptData',
    'gisDrillingDocuments',
] as const;
export const GIS_DRILLING_CURVES_TYPES = ['gisCurvesParamsDrillingWells2'] as const;
export const GIS_CONTROL_CURVES_TYPES = ['gisCurvesParamsDrillingWells'] as const;
export const GRP_TYPES = [] as const;
export const GTM_TYPES = ['performedGtmData', 'increaseOilTaking', 'plannedGtmData', 'doneReportGTM'] as const;
export const RESERVOIR_PRESSURES_TYPES = [] as const;
export const MEASUREMENTS_TYPES = ['technologicalMeasurements'] as const;
export const FLUID_TYPES = [
    'deepOilSamples',
    'oilComponentComposition',
    'surfaceOilSamples',
    'waterComposition',
    'associatedGasComposition',
    'stableCondensateComposition',
    'dissolvedGasComposition',
    'freeGasComposition',
    'samplesCount',
] as const;
export const COORDINATES_TYPES = ['coordinatesData', 'inclinometryVnk', 'wellPath', 'altitude'] as const;
export const CONSERVATION_TYPES2 = [] as const;
export const MODELING_TYPES = [
    'wellOperationParams',
    'wellTrajectory',
    'analyzeWorkParams',
    'specificProductivity',
    'modelingIsolation',
    'modelingPerforation',
    'wellDebitParams',
    'irapRmsBreakdowns',
    'eventsOnWells',
] as const;
export const TESTING_TYPES = ['testingData', 'columnResearches'] as const;
export const DEVELOPMENT_HISTORY_TYPES = [] as const;
export const REPORTS_NIPI_TYPES = [
    'charactesticWorksGas',
    'charactesticWorksPumping',
    'charactesticWorksInjecting',
] as const;
export const UNDERGROUND_EQUIPMENT_TYPES = ['geophysicalInstrument', 'pumps', 'telemetrySystem'] as const;
export const POTENTIALS_TYPES = ['calculatingPotentials'] as const;
export const WELL_BREAKDOWN_TYPES = [
    'gisTabularConclusions',
    'perforatedReservoirs',
    'wellBreakdownData',
    'perforatedSeams',
    'ipPartsProfile',
] as const;
export const REGISTRY_TYPES = [
    'currentWellStockData',
    'accumulatedWellStockData',
    'registryData',
    'fullWellRegistry',
    'horizontalWells',
] as const;
export const GDIS_RESULTS_TYPES = ['gdisReportGeneration'] as const;
export const REPAIRS_TYPES = [
    'oisActs',
    'repairDrillingData',
    'repairDevelopmentData',
    'summaryRepairPkrsData',
    'summaryRepairDrillingData',
    'summaryRepairDevelopmentData',
    'repairLiquidationData',
    'wellConservationWorks',
    'repairData',
] as const;
export const REFERENCE_TYPES = [] as const;
export const STRATIGRAPHIC_BREAKDOWN_TYPES = ['stratigraphyData'] as const;
export const PRESSURE_DATA_TYPES = ['reservoirPressuresByWells', 'averageWeightedPressures'] as const;
export const WELL_TESTING_TYPES = [] as const;
export const LIQUIDATION_TYPES = ['wellAbandonmentData', 'drillingAndAbandonmentData'] as const;

export const allRequestsBlockTypes = [
    ...DRILLING_TYPES,
    ...ISOLATION_TYPES,
    ...DRILLING_HISTORY_TYPES,
    ...CORE_TYPES,
    ...CONSERVATION_TYPES,
    ...CONSTRUCTION_TYPES,
    ...PERFORATION_TYPES,
    ...TEXHNICAL_INFORMATION_ON_WELLS,
    ...INCLINOMETRY_TYPES,
    ...GIS_CONTROL_CONCLUSION_TYPES,
    ...GIS_DRILLING_CONCLUSION_TYPES,
    ...GIS_DRILLING_CURVES_TYPES,
    ...GIS_CONTROL_CURVES_TYPES,
    ...GRP_TYPES,
    ...GTM_TYPES,
    ...RESERVOIR_PRESSURES_TYPES,
    ...PRESSURE_DATA_TYPES,
    ...MEASUREMENTS_TYPES,
    ...FLUID_TYPES,
    ...COORDINATES_TYPES,
    ...MODELING_TYPES,
    ...TESTING_TYPES,
    ...REPORTS_NIPI_TYPES,
    ...UNDERGROUND_EQUIPMENT_TYPES,
    ...POTENTIALS_TYPES,
    ...WELL_BREAKDOWN_TYPES,
    ...REGISTRY_TYPES,
    ...GDIS_RESULTS_TYPES,
    ...REPAIRS_TYPES,
    ...REFERENCE_TYPES,
    ...STRATIGRAPHIC_BREAKDOWN_TYPES,
    ...LIQUIDATION_TYPES,
] as const;

// Типы для каждого блока
export type DrillingType = (typeof DRILLING_TYPES)[number];
export type GISControlConclusionType = (typeof GIS_CONTROL_CONCLUSION_TYPES)[number];
export type IsolationType = (typeof ISOLATION_TYPES)[number];
export type DrillingHistoryType = (typeof DRILLING_HISTORY_TYPES)[number];
export type ConstructionType = (typeof CONSTRUCTION_TYPES)[number];
export type ConservationType = (typeof CONSERVATION_TYPES)[number];
export type CoreType = (typeof CORE_TYPES)[number];
export type DevelopmentType = (typeof DEVELOPMENT_TYPES)[number];
export type PerforationType = (typeof PERFORATION_TYPES)[number];
export type TechnicalInformationOnWellsType = (typeof TEXHNICAL_INFORMATION_ON_WELLS)[number];
export type InclinometryType = (typeof INCLINOMETRY_TYPES)[number];
export type GISDrillingConclusionType = (typeof GIS_DRILLING_CONCLUSION_TYPES)[number];
export type GISDrillingCurvesType = (typeof GIS_DRILLING_CURVES_TYPES)[number];
export type GISControlCurvesType = (typeof GIS_CONTROL_CURVES_TYPES)[number];
export type GRPType = (typeof GRP_TYPES)[number];
export type GTMType = (typeof GTM_TYPES)[number];
export type ReservoirPressuresType = (typeof RESERVOIR_PRESSURES_TYPES)[number];
export type MeasurementsType = (typeof MEASUREMENTS_TYPES)[number];
export type FluidType = (typeof FLUID_TYPES)[number];
export type CoordinatesType = (typeof COORDINATES_TYPES)[number];
export type ModelingType = (typeof MODELING_TYPES)[number];
export type TestingType = (typeof TESTING_TYPES)[number];
export type ReportsNIPIType = (typeof REPORTS_NIPI_TYPES)[number];
export type UndergroundEquipmentType = (typeof UNDERGROUND_EQUIPMENT_TYPES)[number];
export type PotentialsType = (typeof POTENTIALS_TYPES)[number];
export type WellBreakdownType = (typeof WELL_BREAKDOWN_TYPES)[number];
export type RegistryType = (typeof REGISTRY_TYPES)[number];
export type GDISResultsType = (typeof GDIS_RESULTS_TYPES)[number];
export type RepairsType = (typeof REPAIRS_TYPES)[number];
export type ReferenceType = (typeof REFERENCE_TYPES)[number];
export type StratigraphicBreakdownType = (typeof STRATIGRAPHIC_BREAKDOWN_TYPES)[number];
export type LiquidationType = (typeof LIQUIDATION_TYPES)[number];
export type PressureType = (typeof PRESSURE_DATA_TYPES)[number];

// Объединяющий тип
export type AllRequestsBlockTypes = (typeof allRequestsBlockTypes)[number];

export type RequestTemplateProps = {
    title: string;
    key: string;
    description: string;
};

export type RequestButtonProps = {
    title: string;
    key: string;
};
